var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 13.37V5a1 1 0 1 1 2 0v8.467l2.631-2.924a1 1 0 0 1 1.487 1.338l-5.012 5.568a.085.085 0 0 1-.126 0L6.97 11.881a1 1 0 1 1 1.487-1.338L11 13.371ZM20 15a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6a1 1 0 1 1 2 0v5h16v-5Z"
  })));
};
export default SvgDownload;